module.exports = __webpack_public_path__ + "assets/img/105.06f11940.png";